/*example*/
/*options*/
/*--docker*/
/*--out-dir-path*/
/*--use-gitignorebool*/
/*comparison-to-pnpm-deploy*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "prune",
  "description": "`turbo prune` 命令的 API 参考"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "为目标软件包生成部分 monorepo。输出将被放置到名为 out 的目录中，其中包含以下内容："
  }, {
    "heading": "",
    "content": "¥Generate a partial monorepo for a target package. The output will be placed into a directory named out containing the following:"
  }, {
    "heading": "",
    "content": "构建目标所需的所有内部包的完整源代码。"
  }, {
    "heading": "",
    "content": "¥The full source code of all internal packages needed to build the target."
  }, {
    "heading": "",
    "content": "包含构建目标所需的原始锁文件子集的精简锁文件。"
  }, {
    "heading": "",
    "content": "¥A pruned lockfile containing the subset of the original lockfile needed to build the target."
  }, {
    "heading": "",
    "content": "根 package.json 的副本。"
  }, {
    "heading": "",
    "content": "¥A copy of the root package.json."
  }, {
    "heading": "示例-example",
    "content": "¥Example"
  }, {
    "heading": "示例-example",
    "content": "从具有以下结构的仓库开始："
  }, {
    "heading": "示例-example",
    "content": "¥Starting with a repository with the following structure:"
  }, {
    "heading": "示例-example",
    "content": "运行 turbo prune frontend 以在 out 目录中为 frontend 应用生成精简的工作区："
  }, {
    "heading": "示例-example",
    "content": "¥Run turbo prune frontend to generate a pruned workspace for the frontend application in an out directory:"
  }, {
    "heading": "选项-options",
    "content": "¥Options"
  }, {
    "heading": "--docker---docker",
    "content": "默认为 false。"
  }, {
    "heading": "--docker---docker",
    "content": "¥Defaults to false."
  }, {
    "heading": "--docker---docker",
    "content": "更改输出目录，使其更易于与 Docker 最佳实践和层缓存 一起使用。目录将包含："
  }, {
    "heading": "--docker---docker",
    "content": "¥Alter the output directory to make it easier to use with Docker best practices and layer caching. The directory will contain:"
  }, {
    "heading": "--docker---docker",
    "content": "一个名为 json 的文件夹，其中包含已精简工作区的 package.json 文件。"
  }, {
    "heading": "--docker---docker",
    "content": "¥A folder named json with the pruned workspace's package.json files."
  }, {
    "heading": "--docker---docker",
    "content": "一个名为 full 的文件夹，其中包含已精简工作区中构建目标所需的内部包的完整源代码。"
  }, {
    "heading": "--docker---docker",
    "content": "¥A folder named full with the pruned workspace's full source code for the internal packages needed to build the target."
  }, {
    "heading": "--docker---docker",
    "content": "包含构建目标所需的原始锁文件子集的精简锁文件。"
  }, {
    "heading": "--docker---docker",
    "content": "¥A pruned lockfile containing the subset of the original lockfile needed to build the target."
  }, {
    "heading": "--docker---docker",
    "content": "使用与上述相同的示例，运行 turbo prune frontend --docker 将生成以下内容："
  }, {
    "heading": "--docker---docker",
    "content": "¥Using the same example from above, running turbo prune frontend --docker will generate the following:"
  }, {
    "heading": "--out-dir-path---out-dir-path",
    "content": "默认为 ./out。"
  }, {
    "heading": "--out-dir-path---out-dir-path",
    "content": "¥Defaults to ./out."
  }, {
    "heading": "--out-dir-path---out-dir-path",
    "content": "自定义生成修剪输出的目录。"
  }, {
    "heading": "--out-dir-path---out-dir-path",
    "content": "¥Customize the directory the pruned output is generated in."
  }, {
    "heading": "--use-gitignorebool---use-gitignorebool",
    "content": "默认：true"
  }, {
    "heading": "--use-gitignorebool---use-gitignorebool",
    "content": "¥Default: true"
  }, {
    "heading": "--use-gitignorebool---use-gitignorebool",
    "content": "将文件复制到输出目录时，请考虑 .gitignore 文件。"
  }, {
    "heading": "--use-gitignorebool---use-gitignorebool",
    "content": "¥Respect .gitignore file(s) when copying files to the output directory."
  }, {
    "heading": "与-pnpm-deploy-的比较-comparison-to-pnpm-deploy",
    "content": "¥Comparison to pnpm deploy"
  }, {
    "heading": "与-pnpm-deploy-的比较-comparison-to-pnpm-deploy",
    "content": "虽然 turbo prune 和 pnpm deploy 都用于隔离 monorepo 中的包，但它们服务于不同的用途并产生不同的输出。"
  }, {
    "heading": "与-pnpm-deploy-的比较-comparison-to-pnpm-deploy",
    "content": "¥While both turbo prune and pnpm deploy are used to isolate packages in a monorepo, they serve different purposes and produce different outputs."
  }, {
    "heading": "与-pnpm-deploy-的比较-comparison-to-pnpm-deploy",
    "content": "turbo prune 生成部分 monorepo，pnpm deploy 生成仅包含目标包内容的目录。"
  }, {
    "heading": "与-pnpm-deploy-的比较-comparison-to-pnpm-deploy",
    "content": "¥Where turbo prune generates a partial monorepo, pnpm deploy generates a directory that only contains the contents of the target package."
  }, {
    "heading": "与-pnpm-deploy-的比较-comparison-to-pnpm-deploy",
    "content": "pnpm deploy 生成的目录包含一个独立的 node_modules 文件，其中包含硬链接的内部依赖。这会生成一个可移植的包，可以直接复制到服务器并使用，无需额外步骤。由于重点是生成独立的可部署包，因此不会保留仓库结构。"
  }, {
    "heading": "与-pnpm-deploy-的比较-comparison-to-pnpm-deploy",
    "content": "¥The pnpm deploy generated directory has a self-contained node_modules with hard linked internal dependencies.\nThis results in a portable package that can be directly copied to a server and used without additional steps.\nThe repository structure is not retained, as the focus is on producing a standalone deployable package."
  }],
  "headings": [{
    "id": "示例-example",
    "content": "示例 /*example*/"
  }, {
    "id": "选项-options",
    "content": "选项 /*options*/"
  }, {
    "id": "--docker---docker",
    "content": "--docker /*--docker*/"
  }, {
    "id": "--out-dir-path---out-dir-path",
    "content": "--out-dir <path> /*--out-dir-path*/"
  }, {
    "id": "--use-gitignorebool---use-gitignorebool",
    "content": "--use-gitignore[=<bool>] /*--use-gitignorebool*/"
  }, {
    "id": "与-pnpm-deploy-的比较-comparison-to-pnpm-deploy",
    "content": "与 pnpm deploy 的比较 /*comparison-to-pnpm-deploy*/"
  }]
};
import {File, Folder, Files} from '#components/files';
export const toc = [{
  depth: 3,
  url: "#示例-example",
  title: _jsx(_Fragment, {
    children: "示例 "
  })
}, {
  depth: 3,
  url: "#选项-options",
  title: _jsx(_Fragment, {
    children: "选项 "
  })
}, {
  depth: 4,
  url: "#--docker---docker",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--docker"
    }), " "]
  })
}, {
  depth: 4,
  url: "#--out-dir-path---out-dir-path",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--out-dir <path>"
    }), " "]
  })
}, {
  depth: 4,
  url: "#--use-gitignorebool---use-gitignorebool",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--use-gitignore[=<bool>]"
    }), " "]
  })
}, {
  depth: 3,
  url: "#与-pnpm-deploy-的比较-comparison-to-pnpm-deploy",
  title: _jsxs(_Fragment, {
    children: ["与 ", _jsx("code", {
      children: "pnpm deploy"
    }), " 的比较 "]
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["为目标软件包生成部分 monorepo。输出将被放置到名为 ", _jsx(_components.code, {
        children: "out"
      }), " 的目录中，其中包含以下内容："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Generate a partial monorepo for a target package. The output will be placed into a directory named ", _jsx(_components.code, {
        children: "out"
      }), " containing the following:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "构建目标所需的所有内部包的完整源代码。"
        }), "\n", _jsx(_components.p, {
          children: "¥The full source code of all internal packages needed to build the target."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "包含构建目标所需的原始锁文件子集的精简锁文件。"
        }), "\n", _jsx(_components.p, {
          children: "¥A pruned lockfile containing the subset of the original lockfile needed to build the target."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["根 ", _jsx(_components.code, {
            children: "package.json"
          }), " 的副本。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥A copy of the root ", _jsx(_components.code, {
            children: "package.json"
          }), "."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " prune"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [package]"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "示例-example",
      children: "示例 "
    }), "\n", _jsx(_components.p, {
      children: "¥Example"
    }), "\n", _jsx(_components.p, {
      children: "从具有以下结构的仓库开始："
    }), "\n", _jsx(_components.p, {
      children: "¥Starting with a repository with the following structure:"
    }), "\n", _jsxs(Files, {
      children: [_jsx(File, {
        name: "package.json"
      }), _jsx(File, {
        name: "pnpm-lock.yaml"
      }), _jsxs(Folder, {
        name: "apps",
        defaultOpen: true,
        children: [_jsxs(Folder, {
          name: "admin",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "next-env.d.ts"
          }), _jsx(File, {
            name: "next.config.js"
          }), _jsx(Folder, {
            name: "src",
            children: _jsx(Folder, {
              name: "app",
              children: _jsx(File, {
                name: "page.tsx"
              })
            })
          }), _jsx(File, {
            name: "tsconfig.json"
          })]
        }), _jsxs(Folder, {
          name: "frontend",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "next-env.d.ts"
          }), _jsx(File, {
            name: "next.config.js"
          }), _jsx(Folder, {
            name: "src",
            children: _jsx(Folder, {
              name: "app",
              children: _jsx(File, {
                name: "page.tsx"
              })
            })
          }), _jsx(File, {
            name: "tsconfig.json"
          })]
        })]
      }), _jsxs(Folder, {
        name: "packages",
        defaultOpen: true,
        children: [_jsxs(Folder, {
          name: "scripts",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(Folder, {
            name: "src",
            children: _jsx(File, {
              name: "index.tsx"
            })
          }), _jsx(File, {
            name: "tsconfig.json"
          })]
        }), _jsxs(Folder, {
          name: "shared",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsxs(Folder, {
            name: "src",
            children: [_jsxs(Folder, {
              name: "__tests__",
              children: [_jsx(File, {
                name: "sum.test.ts"
              }), _jsx(File, {
                name: "tsconfig.json"
              })]
            }), _jsx(File, {
              name: "index.ts"
            }), _jsx(File, {
              name: "sum.ts"
            })]
          }), _jsx(File, {
            name: "tsconfig.json"
          })]
        }), _jsxs(Folder, {
          name: "ui",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(Folder, {
            name: "src",
            children: _jsx(File, {
              name: "index.tsx"
            })
          }), _jsx(File, {
            name: "tsconfig.json"
          })]
        }), _jsxs(Folder, {
          name: "utils",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(Folder, {
            name: "src",
            children: _jsx(File, {
              name: "index.tsx"
            })
          }), _jsx(File, {
            name: "tsconfig.json"
          })]
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["运行 ", _jsx(_components.code, {
        children: "turbo prune frontend"
      }), " 以在 ", _jsx(_components.code, {
        children: "out"
      }), " 目录中为 ", _jsx(_components.code, {
        children: "frontend"
      }), " 应用生成精简的工作区："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Run ", _jsx(_components.code, {
        children: "turbo prune frontend"
      }), " to generate a pruned workspace for the ", _jsx(_components.code, {
        children: "frontend"
      }), " application in an ", _jsx(_components.code, {
        children: "out"
      }), " directory:"]
    }), "\n", _jsxs(Files, {
      children: [_jsx(File, {
        name: "package.json"
      }), _jsx(File, {
        name: "pnpm-lock.yaml (partial)"
      }), _jsx(Folder, {
        name: "apps",
        defaultOpen: true,
        children: _jsxs(Folder, {
          name: "frontend",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "next-env.d.ts"
          }), _jsx(File, {
            name: "next.config.js"
          }), _jsx(Folder, {
            name: "src",
            children: _jsx(Folder, {
              name: "app",
              children: _jsx(File, {
                name: "page.tsx"
              })
            })
          }), _jsx(File, {
            name: "tsconfig.json"
          })]
        })
      }), _jsxs(Folder, {
        name: "packages",
        defaultOpen: true,
        children: [_jsxs(Folder, {
          name: "shared",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsxs(Folder, {
            name: "src",
            children: [_jsxs(Folder, {
              name: "__tests__",
              children: [_jsx(File, {
                name: "sum.test.ts"
              }), _jsx(File, {
                name: "tsconfig.json"
              })]
            }), _jsx(File, {
              name: "index.ts"
            }), _jsx(File, {
              name: "sum.ts"
            })]
          }), _jsx(File, {
            name: "tsconfig.json"
          })]
        }), _jsxs(Folder, {
          name: "ui",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(Folder, {
            name: "src",
            children: _jsx(File, {
              name: "index.tsx"
            })
          }), _jsx(File, {
            name: "tsconfig.json"
          })]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "选项-options",
      children: "选项 "
    }), "\n", _jsx(_components.p, {
      children: "¥Options"
    }), "\n", _jsxs(_components.h4, {
      id: "--docker---docker",
      children: [_jsx(_components.code, {
        children: "--docker"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认为 ", _jsx(_components.code, {
        children: "false"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Defaults to ", _jsx(_components.code, {
        children: "false"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["更改输出目录，使其更易于与 ", _jsx(_components.a, {
        href: "https://docs.docker.com/develop/develop-images/dockerfile_best-practices/",
        children: "Docker 最佳实践和层缓存"
      }), " 一起使用。目录将包含："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Alter the output directory to make it easier to use with ", _jsx(_components.a, {
        href: "https://docs.docker.com/develop/develop-images/dockerfile_best-practices/",
        children: "Docker best practices and layer caching"
      }), ". The directory will contain:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["一个名为 ", _jsx(_components.code, {
            children: "json"
          }), " 的文件夹，其中包含已精简工作区的 ", _jsx(_components.code, {
            children: "package.json"
          }), " 文件。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥A folder named ", _jsx(_components.code, {
            children: "json"
          }), " with the pruned workspace's ", _jsx(_components.code, {
            children: "package.json"
          }), " files."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["一个名为 ", _jsx(_components.code, {
            children: "full"
          }), " 的文件夹，其中包含已精简工作区中构建目标所需的内部包的完整源代码。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥A folder named ", _jsx(_components.code, {
            children: "full"
          }), " with the pruned workspace's full source code for the internal packages needed to build the target."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "包含构建目标所需的原始锁文件子集的精简锁文件。"
        }), "\n", _jsx(_components.p, {
          children: "¥A pruned lockfile containing the subset of the original lockfile needed to build the target."
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["使用与上述相同的示例，运行 ", _jsx(_components.code, {
        children: "turbo prune frontend --docker"
      }), " 将生成以下内容："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Using the same example from above, running ", _jsx(_components.code, {
        children: "turbo prune frontend --docker"
      }), " will generate the following:"]
    }), "\n", _jsxs(Files, {
      children: [_jsx(File, {
        name: "pnpm-lock.yaml (partial)"
      }), _jsxs(Folder, {
        name: "full",
        defaultOpen: true,
        children: [_jsx(File, {
          name: "package.json (from repo root)"
        }), _jsx(Folder, {
          name: "apps",
          children: _jsxs(Folder, {
            name: "frontend",
            children: [_jsx(File, {
              name: "package.json"
            }), _jsx(File, {
              name: "next-env.d.ts"
            }), _jsx(File, {
              name: "next.config.js"
            }), _jsx(Folder, {
              name: "src",
              children: _jsx(Folder, {
                name: "app",
                children: _jsx(File, {
                  name: "page.tsx"
                })
              })
            }), _jsx(File, {
              name: "tsconfig.json"
            })]
          })
        }), _jsxs(Folder, {
          name: "packages",
          children: [_jsxs(Folder, {
            name: "shared",
            children: [_jsx(File, {
              name: "package.json"
            }), _jsxs(Folder, {
              name: "src",
              children: [_jsxs(Folder, {
                name: "__tests__",
                children: [_jsx(File, {
                  name: "sum.test.ts"
                }), _jsx(File, {
                  name: "tsconfig.json"
                })]
              }), _jsx(File, {
                name: "index.ts"
              }), _jsx(File, {
                name: "sum.ts"
              })]
            }), _jsx(File, {
              name: "tsconfig.json"
            })]
          }), _jsxs(Folder, {
            name: "ui",
            children: [_jsx(File, {
              name: "package.json"
            }), _jsx(Folder, {
              name: "src",
              children: _jsx(File, {
                name: "index.tsx"
              })
            }), _jsx(File, {
              name: "tsconfig.json"
            })]
          })]
        })]
      }), _jsxs(Folder, {
        name: "json",
        defaultOpen: true,
        children: [_jsx(File, {
          name: "package.json (from repo root)"
        }), _jsx(Folder, {
          name: "apps",
          defaultOpen: true,
          children: _jsx(Folder, {
            name: "frontend",
            defaultOpen: true,
            children: _jsx(File, {
              name: "package.json"
            })
          })
        }), _jsxs(Folder, {
          name: "packages",
          defaultOpen: true,
          children: [_jsx(Folder, {
            name: "ui",
            defaultOpen: true,
            children: _jsx(File, {
              name: "package.json"
            })
          }), _jsx(Folder, {
            name: "shared",
            defaultOpen: true,
            children: _jsx(File, {
              name: "package.json"
            })
          })]
        })]
      })]
    }), "\n", _jsxs(_components.h4, {
      id: "--out-dir-path---out-dir-path",
      children: [_jsx(_components.code, {
        children: "--out-dir <path>"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认为 ", _jsx(_components.code, {
        children: "./out"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Defaults to ", _jsx(_components.code, {
        children: "./out"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "自定义生成修剪输出的目录。"
    }), "\n", _jsx(_components.p, {
      children: "¥Customize the directory the pruned output is generated in."
    }), "\n", _jsxs(_components.h4, {
      id: "--use-gitignorebool---use-gitignorebool",
      children: [_jsx(_components.code, {
        children: "--use-gitignore[=<bool>]"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "true"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "true"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["将文件复制到输出目录时，请考虑 ", _jsx(_components.code, {
        children: ".gitignore"
      }), " 文件。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Respect ", _jsx(_components.code, {
        children: ".gitignore"
      }), " file(s) when copying files to the output directory."]
    }), "\n", _jsxs(_components.h3, {
      id: "与-pnpm-deploy-的比较-comparison-to-pnpm-deploy",
      children: ["与 ", _jsx(_components.code, {
        children: "pnpm deploy"
      }), " 的比较 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Comparison to ", _jsx(_components.code, {
        children: "pnpm deploy"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["虽然 ", _jsx(_components.code, {
        children: "turbo prune"
      }), " 和 ", _jsx(_components.a, {
        href: "https://pnpm.nodejs.cn/cli/deploy",
        children: _jsx(_components.code, {
          children: "pnpm deploy"
        })
      }), " 都用于隔离 monorepo 中的包，但它们服务于不同的用途并产生不同的输出。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥While both ", _jsx(_components.code, {
        children: "turbo prune"
      }), " and ", _jsx(_components.a, {
        href: "https://pnpm.nodejs.cn/cli/deploy",
        children: _jsx(_components.code, {
          children: "pnpm deploy"
        })
      }), " are used to isolate packages in a monorepo, they serve different purposes and produce different outputs."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo prune"
      }), " 生成部分 monorepo，", _jsx(_components.code, {
        children: "pnpm deploy"
      }), " 生成仅包含目标包内容的目录。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Where ", _jsx(_components.code, {
        children: "turbo prune"
      }), " generates a partial monorepo, ", _jsx(_components.code, {
        children: "pnpm deploy"
      }), " generates a directory that only contains the contents of the target package."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "pnpm deploy"
      }), " 生成的目录包含一个独立的 ", _jsx(_components.code, {
        children: "node_modules"
      }), " 文件，其中包含硬链接的内部依赖。这会生成一个可移植的包，可以直接复制到服务器并使用，无需额外步骤。由于重点是生成独立的可部署包，因此不会保留仓库结构。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ", _jsx(_components.code, {
        children: "pnpm deploy"
      }), " generated directory has a self-contained ", _jsx(_components.code, {
        children: "node_modules"
      }), " with hard linked internal dependencies.\nThis results in a portable package that can be directly copied to a server and used without additional steps.\nThe repository structure is not retained, as the focus is on producing a standalone deployable package."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
